import { Component, OnInit } from '@angular/core';

declare const $: any;
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  screenWidth: number = window.innerWidth;
  isMobile: boolean = this.screenWidth < 1024;

constructor() {
  window.addEventListener('resize', () => {
    this.screenWidth = window.innerWidth;
    this.isMobile = this.screenWidth < 1024;
  });
}

  ngOnInit(): void {
  }

  ngAfterViewInit() {


    $(document).ready( () => {
      // Open submenu on click
      $('.dropdown-submenu a.dropdown-toggle').on("click",  (e: { stopPropagation: () => void; preventDefault: () => void; }) => {
        $(this).next('ul').toggle();
        e.stopPropagation();
        e.preventDefault();
      });

      // Open submenu on hover
      $('.dropdown-submenu').on("mouseenter",  () => {
        $(this).children('.dropdown-menu').show();
      }).on("mouseleave",  () => {
        $(this).children('.dropdown-menu').hide();
      });
    });

    //mega menu
    $(".tr-menu").hover(function () {
      $(".cat-menu").fadeIn(500);
    });
    $(".i-head-top").mouseleave(function () {
      $(".cat-menu").fadeOut("500");
    });




  }

}
